export function getPlayerReadableDateString(
  date: string,
  { includeWeekday, includeYear, short }: { includeWeekday?: boolean; includeYear?: boolean; short?: boolean } = {
    includeWeekday: true,
    includeYear: false,
    short: false,
  }
) {
  const d = new Date(date)

  if (short) {
    return d.toLocaleDateString(undefined, {
      timeZone: "UTC",
      weekday: undefined,
      day: "numeric",
      month: "numeric",
      year: includeYear ? "2-digit" : undefined,
    })
  }

  return d.toLocaleDateString(undefined, {
    timeZone: "UTC",
    weekday: includeWeekday ? "long" : undefined,
    day: "numeric",
    month: "long",
    year: includeYear ? "numeric" : undefined,
  })
}
